import { tickerItems } from '@/mocks/home';

export default function TopTicker() {
  const loop = [...tickerItems, ...tickerItems];

  return (
    <div className="w-full bg-foreground-950 text-background-50">
      <div className="mx-auto flex max-w-[1280px] items-center gap-3 px-4 py-2 md:px-6">
        <span className="flex shrink-0 items-center gap-1.5 rounded-full bg-accent-500 px-2.5 py-1 text-[11px] font-medium text-foreground-950">
          <span className="flex h-3.5 w-3.5 items-center justify-center">
            <i className="ri-flashlight-fill text-[11px]" />
          </span>
          更新条
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-marquee items-center gap-8 whitespace-nowrap text-xs text-background-200">
            {loop.map((item, index) => (
              <span key={`${item}-${index}`} className="flex items-center gap-2">
                <span className="h-1 w-1 rounded-full bg-accent-400" />
                {item}
              </span>
            ))}
          </div>
        </div>
        <a
          href="#updates"
          className="hidden shrink-0 cursor-pointer items-center gap-1 text-xs font-medium text-background-100 transition-colors hover:text-accent-300 md:flex"
        >
          查看全部更新
          <span className="flex h-3.5 w-3.5 items-center justify-center">
            <i className="ri-arrow-right-s-line" />
          </span>
        </a>
      </div>
    </div>
  );
}